import { singleton, inject } from "tsyringe";

// shared
import type { IDateAdapter } from "@/shared/libs/date/interface";

// entities
import type { AiTutorSessionMessageDto } from "@/entities/ai-tutor-session/domain/dtos";
import type { AiTutorSessionBehaviorStructure } from "@/entities/ai-tutor-session/domain/behaviors/AiTutorSessionBehavior";

// pages
import type { MessageItemProps } from "@/pages/ai-tutor/models/interface";

export interface SessionMessagesConverterStructure {
    convert: (sessionMessages: AiTutorSessionMessageDto[]) => MessageItemProps[];
}

@singleton()
export class SessionMessagesConverter implements SessionMessagesConverterStructure {
    constructor(
        @inject("AiTutorSessionBehavior")
        private readonly aiTutorSessionBehavior: AiTutorSessionBehaviorStructure,
        @inject("DateAdapter")
        private readonly dateAdapter: IDateAdapter,
    ) {}

    public convert = (sessionMessages: AiTutorSessionMessageDto[]): MessageItemProps[] => {
        return sessionMessages.map((sessionMessage) => {
            const messageItem: MessageItemProps = {
                id: sessionMessage.id,
                role: sessionMessage.role,
                message: "",
                createdAt: "",
            };

            if (this.aiTutorSessionBehavior.isUserSessionMessage(sessionMessage)) {
                messageItem.message = sessionMessage.contents[0].value;
                messageItem.createdAt = this.dateAdapter.formatTimeWithMeridiem(
                    sessionMessage.createdAt,
                );
            } else if (this.aiTutorSessionBehavior.isAssistantSessionMessage(sessionMessage)) {
                if (
                    this.aiTutorSessionBehavior.isAssistantSessionMessageCompleted(sessionMessage)
                ) {
                    messageItem.message = sessionMessage.contents[0].value;
                    messageItem.createdAt = this.dateAdapter.formatTimeWithMeridiem(
                        sessionMessage.finalizedAt,
                    );
                } else {
                    messageItem.message = "오류가 발생했습니다.";
                    messageItem.createdAt = this.dateAdapter.formatTimeWithMeridiem(
                        sessionMessage.createdAt,
                    );
                }
            } else if (this.aiTutorSessionBehavior.isSystemSessionMessage(sessionMessage)) {
                messageItem.message = sessionMessage.contents[0].value;
                messageItem.createdAt = this.dateAdapter.formatTimeWithMeridiem(
                    sessionMessage.createdAt,
                );
            } else {
                ((messageItem.message = "-"), (messageItem.createdAt = "-"));
            }

            return messageItem;
        });
    };
}
